<div class="sprite-section">
  <div class="flex-m">
    <img src="/assets/images/sip/icons/piggy-bank-1.png" alt="no image">
    <span class="hr mt-3"></span>
    <div class="text mt-4">
      <div class="head">Its Affordable</div>
      <div class="descr">
        No matter what you give, every donation will make an impact
      </div>
    </div>
  </div>
  <div class="flex-m">
    <img src="/assets/images/sip/icons/happy-1.png" alt="no image">
    <span class="hr mt-3"></span>
    <div class="text mt-4">
      <div class="head">It's a Community</div>
      <div class="descr">
        Be part of an inspiring group, changing lives every month
      </div>
    </div>
  </div>
  <div class="flex-m">
    <img src="/assets/images/sip/icons/love-1.png" alt="no image">
    <span class="hr mt-3"></span>
    <div class="text mt-4">
      <div class="head">It's Transparent</div>
      <div class="descr">
        You'll receive regular updates on your donations
      </div>
    </div>
  </div>
  <div [ngClass]="{'mbm': params?.utm_campaign?.includes('mbm')}">
    <div class="outer-div">
      <div class="flex-m inner-div">
        <img src="/assets/images/sip/icons/magic-ball-1.png" alt="no image">
        <span class="hr mt-3"></span>
        <div class="text mt-4">
          <div class="head">It's an Investment</div>
          <div class="descr">
            Your contributions will fund your medical emergencies
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
